// Google Ads consent wiring (Consent Mode v2). Mirrors the TikTok/PostHog
// consent bridges but pushes gtag `consent: update` signals for the marketing
// category. Safe to call before gtag.js has finished loading: the inline
// bootstrap defines `window.gtag`, which queues the update on `dataLayer` until
// the library processes it.

import type { ConsentValue } from "@/features/consent/consent-storage";

type GtagFn = (...args: unknown[]) => void;

function getGtag(): GtagFn | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (window as unknown as { gtag?: GtagFn }).gtag;
}

export function applyGoogleAdsConsent(
  marketing: ConsentValue,
  analytics: ConsentValue = "denied",
): void {
  const gtag = getGtag();
  if (!gtag) {
    // Bootstrap snippet hasn't run yet (or the tag is unconfigured). It seeds
    // the initial consent default from storage on its own, so there is nothing
    // to correct here.
    return;
  }
  // The advertising signals are tied to the marketing category. Denying them
  // does not stop measurement: the tag still loads on every page and
  // `url_passthrough` (see gtag-snippet.ts) carries the click id in the URL,
  // so Google can attribute and model conversions cookielessly.
  gtag("consent", "update", {
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
    analytics_storage: analytics,
  });
}
